import config from '../config';
import { preparePostRequest, handleResponse } from '../_helpers';

export const importDevicesService = {
    upload,
    submit
};


function upload(request, client_id) {
    const requestOptions = preparePostRequest(request);

    return fetch(`${config.apiUrl}importDevices/client/${client_id}`, requestOptions).then(handleResponse);
}

function submit(request, client_id, code) {
    const requestOptions = preparePostRequest(request);

    return fetch(`${config.apiUrl}importDevices/client/${client_id}/code/${code}`, requestOptions).then(handleResponse);
}
